export const environment = {
    production: true,
    baseURL: 'https://wecodeit.at',
    contactEndpoint:
        'https://idx-contact-handler-96446424-1030852214745.europe-west3.run.app/contact',
    contentful: {
        space: 'zoat2da3x3pl',
        accessToken: 'tBXcuFuiXYvWJcPO0g_xgW6OAM6YO7uZRPtIKzUDQ9U',
    },
};
